module.exports = __webpack_public_path__ + "img/Overstay_Engine_On.f16a7211.png";